import { useForm } from "react-hook-form";
import { ListPepole } from "./ListPepole";
import { useEffect, useState } from "react";
import {
  AddBeneficiaries,
  GetBeneficiaries,
  sendOtp,
} from "../../services/beneficiaries";
import { api, handleToast } from "../../services/config";
import { ToastContainer } from "react-toastify";
import { Loading } from "../common/Loading";
import { contextApi } from "../../context/contextApi";
import { useContext } from "react";

export const WalletForm = () => {
  const formatFullName = (name, lastName) => {
    if (!name && !lastName) return "نامشخص";
    if (name === lastName) return lastName || name;
    return `${name || ""} ${lastName || ""}`.trim();
  };

  const context = useContext(contextApi);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange" });
  const onSubmit = (data) => AddBeneficiarie(data);
  const [pepole, setPepole] = useState([]);
  const [shebaInfo, setShebaInfo] = useState("");
  const [load, setLoad] = useState(false);
  const [timer, setTimer] = useState(0);

  const handleInquiry = async () => {
    const shebaValue = watch("sheba");
    const userType = watch("user_type");

    if (!shebaValue || shebaValue.length !== 26) {
      handleToast("error", "لطفا شماره شبا را به درستی وارد کنید");
      return;
    }

    if (!userType) {
      handleToast("error", "لطفا نوع کیف پول را انتخاب کنید");
      return;
    }

    try {
      setLoad(true);

      const token = localStorage.getItem("login");

      const response = await api.post(
        "inquiry/sheba",
        { sheba: shebaValue },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200) {
        const shebaInfo = response.data.data;
        const owner = shebaInfo?.owners?.[0] || {};

        const fullName = formatFullName(owner.first_name, owner.last_name);

        setShebaInfo(fullName);
        setValue("name", fullName);
        setValue("bank_name", shebaInfo.bank_name);
        setValue("description", shebaInfo.description);
        setValue("returned_sheba", shebaInfo.sheba);

        // پیام backend
        handleToast("success", response.data.message);
      } else {
        throw new Error("Response not OK");
      }
    } catch (error) {
      console.error("Inquiry Error:", error);
      if (error.response?.data) {
        const backendMessage = error.response.data.message;
        const backendError = error.response.data.errors?.[0];

        handleToast("error", backendError || backendMessage);
      } else {
        handleToast("error", "خطایی رخ داده است");
      }
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    const storedStartTime = localStorage.getItem("startTime");

    const currentTime = Math.floor(Date.now() / 1000);
    const elapsedTime = currentTime - parseInt(storedStartTime, 10);
    if (elapsedTime < 120) {
      setTimer(120 - elapsedTime);
    }
  }, []);

  const dataForm = [
    {
      title: "شماره شبا",
      registerOption: "sheba",
      options: {
        required: { value: true, message: "این فیلد اجباری می باشد" },
        pattern: {
          value: /^(?:IR)(?=.{24}$)[0-9]*$/,
          message: "فرمت شماره شبای شما نادرست است",
        },
      },
      type: "input",
      placeholder: "IR",
      inputType: "text",
    },
    {
      title: "نوع کیف پول",
      registerOption: "user_type",
      options: {
        required: { value: true, message: "این فیلد اجباری می باشد" },
      },
      type: "select",
      inputType: "text",
      hasInquiryButton: true,
    },
    {
      title: "نام طرف حساب",
      registerOption: "name",
      options: {
        required: { value: true, message: "این فیلد اجباری می باشد" },
      },
      type: "input",
      inputType: "text",
      readOnly: true,
    },

    {
      title: "موبایل(بدون صفر)",
      registerOption: "mobile",
      options: {
        required: {
          value: true,
          message: "این فیلد اجباری می باشد",
        },
        pattern: {
          value: /^9\d{9}$/,
          message: "فرمت شماره موبایل شما نادرست است",
        },
      },
      type: "input",
      placeholder: "شماره موبایل را بدون ۰ وارد کنید",
      inputType: "number",
    },
    {
      title: "کدتایید",
      registerOption: "otp",
      options: {
        required: { value: true, message: "این فیلد اجباری می باشد" },
      },
      type: "input",
      inputType: "number",
      btn: true,
    },
  ];
  const GetBeneficiaryList = async () => {
    try {
      const res = await GetBeneficiaries();
      setPepole(res || []);
    } catch (error) {}
  };

  const handleDeleted = (id) => {
    setPepole((prev) => prev.filter((item) => item.id !== id));
    GetBeneficiaryList();
  };

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const handlSendOTP = async () => {
    const mobileValue = watch("mobile");

    // چک کردن اینکه موبایل وارد شده باشد
    if (!mobileValue || !/^9\d{9}$/.test(mobileValue)) {
      handleToast("error", "لطفا شماره موبایل را به درستی وارد کنید");
      return;
    }

    const startTime = Math.floor(Date.now() / 1000);
    localStorage.setItem("startTime", startTime.toString());
    setTimer(120);
    const bodyOtp = {
      mobile: localStorage.mobile, // استفاده از موبایل وارد شده یا موبایل از localStorage
    };
    try {
      setLoad(true);
      await sendOtp(bodyOtp);
      handleToast("success", "کد ارسال شده را وارد کنید");
    } catch (error) {
      setTimer(0);
      localStorage.removeItem("startTime");
      handleToast("error", "خطا در ارسال کد تایید");
    }
    setTimeout(() => {
      setLoad(false);
    }, 500);
  };
  const AddBeneficiarie = async (data) => {
    setLoad(true);
    try {
      data.otp = parseInt(data.otp);
      data.user_type = parseInt(data.user_type);
      data = {
        ...data,
        type: 2,
        lastname: data.name,
      };
      await AddBeneficiaries(data);
    } catch (error) {
      console.log(error);
    }
    setTimeout(() => {
      setLoad(false);
      GetBeneficiaryList();
    }, 400);
  };
  useEffect(() => {
    GetBeneficiaryList();
    return () => GetBeneficiaryList();
  }, []);
  const handlSetInputs = (item) => {
    for (const [key, value] of Object.entries(item)) {
      setValue(key, value);
    }
    setValue("name", formatFullName(item.name, item.lastname));
  };
  const handleClick = (buttonName) => {
    context.recordClick(buttonName);
  };

  const [isDark, setIsDark] = useState(
    () =>
      typeof window !== "undefined" && document.body.classList.contains("dark"),
  );

  useEffect(() => {
    const checkDark = () => setIsDark(document.body.classList.contains("dark"));
    checkDark();
    const observer = new MutationObserver(() => {
      checkDark();
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <ToastContainer />
      <Loading show={load} />
      {pepole?.length === 0 ? (
        <p
          className={`text-center my-6 text-sm ${
            isDark ? "text-white" : "text-black"
          }`}
        >
          هیچ موردی یافت نشد!
        </p>
      ) : (
        <div className=" basis-1/2 w-1/2 m-auto overflow-y-auto max-h-40 pl-2">
          <ListPepole
            isDark={isDark}
            pepole={pepole}
            handlSetInputs={handlSetInputs}
            onDeleted={handleDeleted}
          />
        </div>
      )}
      <div
        className={`form  rounded-2xl shadow p-3 max-w-full md:w-3/4 lg:w-2/4 mx-10 md:mx-auto md:p-3  lg:p-6 ${
          isDark ? "card" : "card2"
        }`}
      >
        <span className=" text-[#0010c6] dark:text-white"> کیف پول جدید</span>

        <form onSubmit={handleSubmit(onSubmit)} className="mt-3">
          {dataForm.map((item) => {
            return (
              <div key={item.title}>
                <label
                  htmlFor=""
                  className="text-xs text-[#0010c6] dark:text-white m-0 2"
                >
                  {item.title}
                </label>
                {item.type === "select" ? (
                  <>
                    <div className="flex gap-2">
                      <select
                        name={item.registerOption}
                        {...register(item.registerOption, item.options)}
                        className={`flex-1 text-black bg-gray-100 dark:bg-gray-400 border rounded-md px-2 py-1 text-xs  font-normal outline-none ${
                          (errors[item.registerOption] &&
                            "bg-red-100 border border-red-400") ||
                          ""
                        }`}
                        id=""
                      >
                        <option value="">انتخاب کنید</option>
                        <option value="1">ریالی</option>
                        <option value="2">تتر</option>
                        <option value="3">رمز ارز</option>
                        <option value="4">طلا</option>
                      </select>
                      {item.hasInquiryButton && (
                        <button
                          onClick={handleInquiry}
                          type="button"
                          className="text-center bg-blue-500 px-4 py-1 text-white rounded text-sm whitespace-nowrap"
                        >
                          استعلام
                        </button>
                      )}
                    </div>

                    {errors[item.registerOption] && (
                      <p className="text-red-400 text-xs">
                        {errors[item.registerOption].message}
                      </p>
                    )}
                  </>
                ) : (
                  <div className="relative">
                    <input
                      {...register(item.registerOption, item.options)}
                      placeholder={item.placeholder || ""}
                      type={item.inputType}
                      readOnly={item.readOnly || false}
                      className={` ${
                        item.btn
                          ? " w-2/4 md:w-3/5 text-black"
                          : "w-full text-black"
                      } border rounded-md text-black bg-gray-100 dark:bg-gray-400 px-2 py-1 text-xs placeholder:text-left font-normal outline-none ${
                        (errors[item.registerOption] &&
                          "bg-red-100 border border-red-400") ||
                        ""
                      } ${
                        item.readOnly
                          ? "cursor-not-allowed bg-gray-200 dark:bg-gray-500"
                          : ""
                      }`}
                      defaultValue={
                        item.registerOption === "name" ? shebaInfo : ""
                      }
                    />
                    {item.btn && (
                      <button
                        onClick={handlSendOTP}
                        type="button"
                        className={`text-center bg-blue-500 w-5/12 md:w-2/6 float-left py-1 mr-auto text-white rounded text-sm ${
                          timer > 0
                            ? "opacity-50 bg-gray-500 text-[10px] cursor-not-allowed"
                            : ""
                        }`}
                      >
                        ارسال کد تایید
                        {timer > 0 && ` (${timer}s)`}
                      </button>
                    )}

                    {errors[item.registerOption] && (
                      <p className="text-red-400 text-xs">
                        {errors[item.registerOption].message}
                      </p>
                    )}
                  </div>
                )}
              </div>
            );
          })}
          <input
            onClick={() => {
              handleClick("افزودن در کیف پول ذینفع ها کلیک شد");
            }}
            type="submit"
            disabled={!isValid}
            value={"افزودن"}
            className="btn-add text-center mt-3 shadow disabled:bg-slate-400 bg-green-600 w-full rounded text-white p-1 text-sm"
          />
        </form>
      </div>
    </>
  );
};
